<template>
<nav aria-label="Page navigation">
  <ul class="pagination justify-content-center pagination-sm">
    <template v-if="page == 0">
      <li class="page-item disabled"><a href="#"  class="page-link" aria-label="Previous"><span aria-hidden="true">&laquo;</span></a></li>
    </template>
    <template v-if="page != 0">
      <li class="page-item"><a href="#"  class="page-link" aria-label="Previous" v-on:click.stop.prevent="goto($event)" :pageno="page -1"  aria-hidden="true">&laquo;</a></li>
    </template>   
    <template v-for="(_page, index) in noofpages">
      <template v-if="_page == page"><li class="page-item active"><a href="#"  class="page-link">{{showrecordscount?((_page*noperpage+1)+" - "+ Math.min(((_page+1)*noperpage),maxofrecords) ):_page + 1}} <span class="sr-only">(current)</span></a></li></template>
      <template v-if="_page != page"><li class="page-item"><a  class="page-link" href="#" v-on:click.stop.prevent="goto($event)" :pageno="_page" >{{showrecordscount?((_page*noperpage+1)+" - "+Math.min(((_page+1)*noperpage),maxofrecords) ):_page + 1}}</a></li></template>
    </template>
    <template v-if="page == noofpages[noofpages.length -1]">
      <li class="page-item disabled"><a  class="page-link" href="#" aria-label="Next"><span aria-hidden="true">&raquo;</span></a></li>
    </template>
    <template v-if="page != noofpages[noofpages.length -1]">
      <li class="page-item"><a  class="page-link" href="#" aria-label="Next" v-on:click.stop.prevent="goto($event)" :pageno="page +1"  aria-hidden="true">&raquo;</a></li>
    </template>
  </ul>
</nav>
</template>

<style scoped>
.pagination {
    margin-top: 10px;
    margin-bottom: 0px;
}

.pagination-sm>li>a, .pagination-sm>li>span {
    padding: 5px 5px;
    font-size: 12px;
}

a.page-link {
  border: 0px !important;
  background-color: '' !important; 
  border-color: '' !important; 
}

a {
 color: #b41815 !important;
}

li.active a {
  color: black !important;
  background-color: #fff !important;
}

li.disabled a {
  color: black !important;
  background-color: #fff !important;
}
</style>
<script>
module.exports = {
  props: ['noofpages', 'page', 'noperpage', 'showrecordscount', 'maxofrecords'],
  watch: {
    page: function () {
      if (this.page === -1) {
        this.$emit('goto', event)
      }
    }
  },
  methods: {
    goto: function (event) {
      // pages.page= parseInt($(event.target).attr("pageno"));
      this.$emit('goto', event)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Paginate.vue